import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'element-render-div',
  templateUrl: './element-render-div.component.html',
  styleUrls: ['./element-render-div.component.scss']
})
export class ElementRenderDivComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
